/**
 * エントリーページ サブミット装飾用wrap
 */
export class ContactWrap {

  /**
   * コンストラクタ
   */
  constructor() {
    if (! $('.wpcf7')[0]) {
      return;
    }

    this.PrivacyWrap();
    this.EntryBack();
  }

  /**
   * privacy
   */
  private PrivacyWrap() {
    $('.wpcf7-form-control-wrap.acceptance').before("<div class='p-form__privacy-area'> <p class='title'>個人情報保護方針</p><p class='text'>1. 個人情報の保護についての考え方明星和楽運営委員会は、明星和楽運営委員会の業務を円滑に行うため、お客様の氏名、住所、電話番号、電子メールアドレス等の情報を取得・利用させ</p><p class='text'>段落ですキャプションが入りますキャプションが入りますキャプションが入ります。</p></div>");
  }


  /**
   * ヘッダー変形の高さでエントリページの青背景にis-invisibleトグル
   */
  private EntryBack() {
    $(window).on('scroll', function() {
      if ($('header').hasClass('is-active')) {
        $('.c-entry-back').addClass('is-invisible');
      } else {
        $('.c-entry-back').removeClass('is-invisible');
      }
    });
  }

}